export enum LogLevel {
  Fatal,
  Errors,
  Warnings,
  Notification,
  Info,
  Debug,
}

export enum LanguageEnum {
  English = 'en',
  Arabic = 'ar',
  French = 'fr',
  Indonesian = 'in',
  Urdu = 'ur',
}

export enum ScreenType {
  phone = 'phone',
  tablet = 'tablet',
  desktop = 'desktop',
}

export enum SortDirection {
  None = '',
  Ascending = 'ASC',
  Descending = 'DESC',
}

export enum SortField {
  None = '',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  CreatedAt = 'createdAt',
}

export enum JWTTokenValidation {
  VALID = 'valid',
  NOT_FOUND = 'NotFound',
  EXPIRED = 'Expired',
}

export enum APIURLSegment {}

export enum MediaType {
  IMAGE = 'IMAGE',
  LICENSE = 'LICENSE',
}

export enum Mimetype {
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  SVG = 'image/svg',
  CSV = 'text/csv',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  PPSX = 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLSM = 'application/vnd.ms-excel.sheet.macroenabled.12',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  WPD = 'application/vnd.wordperfect',
  TXT = 'text/plain',
  TEX = 'application/x-tex',
  PDF = 'application/pdf',
}

export enum UserGender {
  MALE = 'male',
  FEMALE = 'female',
}

export enum Genders {
  MALE = 'male',
  FEMALE = 'female',
  CHILD_BOY = 'Child_BOY',
  CHILD_GIRL = 'Child_GIRL',
  BOY = 'boy',
  GIRL = 'girl',
}

export enum UserType {
  STUDENT = 'User_S',
  TEACHER = 'User_T',
  DEPENDENT = 'User_D',
  DEPENDENT_MANAGER = 'User_DM',
}

export enum UploadMediaAction {
  IMAGE = 'profileAvatar',
  IN_APP = 'InApp',
  VIDEO = 'profileVideo',
  CALL_SHARED_FILE = 'callSharedFile',
}

export enum FileType {
  IMAGE = 'Image',
  VIDEO = 'Video',
}

export enum StudentAgePreferenceType {
  FIVE_TO_TWELVE = '5-12',
  THIRTEEN_TO_NINETEEN = '13-19',
  TWENTY_TO_THIRTY_NINE = '20-39',
  FORTY_TO_FIFTY_NINE = '40-59',
  ABOVE_60 = '60+',
}

export enum EducationLevelPreferenceType {
  BEGINNER = 'beginner',
  INTERMEDIATE = 'intermediat',
  ADVANCED = 'advanced',
}

export enum ApplicationName {
  MODDAKIR = 'moddakir',
  BREADA = 'breda',
}

export enum CallStatus {
  COMPLETED = 'completed',
  FAILURE = 'failure',
  NO_ANSWER = 'no_answer',
  TIME_OUT = 'time_out',
  DENIED = 'denied',
  CANCELED = 'canceled',
  NONE = 'none',
}

export enum CallType {
  VOICE = 'Voice',
  VIDEO = 'Video',
}

export enum PackageType {
  FREE = 'free',
  TRANSFERRED = 'transferred',
  PAID = 'paid',
  MANUAL = 'manual',
}

export enum PackageStatus {
  NEW = 'new',
  CURRENT = 'current',
  CONSUMED = 'consumed',
  FREEZED = 'freezed',
  REFUNDED = 'refunded',
  EXPIRED = 'expired',
}

export enum MessageType {
  NOTIFICATION = 'Notification',
}

export enum PaymentTransactionStatus {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}

export enum TeacherRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum StudentRequestStatus {
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum AdminResponse {
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum StudentType {
  NEW = 'New',
  OLD = 'old',
}

export enum LookupsType {
  SESSION_RECORD_TYPE = 'SessionRecordType',
}

export enum WhiteLabelChartFilterActions {
  BENEFICIARIES = 'beneficiaries',
  SESSIONS = 'sessions',
  // LETTERS = 'letters',
  // PAGES = 'pages',
  // MINUTES = 'minutes',
}

export enum ApplicationType {
  MODDAKIR = 'moddakir',
  MODDAKIR_KIDS = 'moddakir_kids',
  BREDA = 'breda',
  WL2 = 'wl_2',
  WL3 = 'wl_3',
  WL5 = 'wl_5',
  WL6 = 'wl_6',
}

export enum MessageProviders {
  EMAIL = 'Email',
  WHATSAPP = 'Whatsapp',
  TELEGRAM = 'Telegram',
  SMS = 'SMS',
  IN_APP = 'InApp',
  APPLICATION = 'App',
}

export enum DashboardChartsType {
  TeachersActive = 'teachersActive',
  TeachersMale = 'teachersMale',
  TeachersFemale = 'teachersFemale',
  StudentsActive = 'studentsActive',
  StudentsMale = 'studentsMale',
  StudentsFemale = 'studentsFemale',
  ConsumedMinutes = 'consumedMinutes',
  Invoices = 'invoices',
}

export enum Exported_Reports_Status {
  PROCESSING = 'processing',
  FINISHED = 'finished',
  FAILED = 'failed',
}

export enum IMAGE_EXTENSIONS {
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
}

export enum VIDEO_EXTENSIONS {
  MP4 = 'mp4',
  AVI = 'avi',
  MOV = 'mov',
  MKV = 'mkv',
  FLV = 'flv',
  WMV = 'wmv',
}

export enum DEVICE_INFO {
  VERSION = 'version',
  TYPE = ' type',
  OS_VERSION = 'osVersion',
  OS_TYPE = 'type',
  MODEL = 'model',
  IP_ADDRESS = 'ipAddress',
  UUID = 'deviceUUID',
}

export enum FileType {
  Excel = '.xlsx',
  PDF = 'application/pdf',
  Images = 'image/*',
  Text = '.txt',
  Word = '.docx',
  CSV = '.csv',
  PowerPoint = '.pptx',
}

export enum NotificationType {
  EXPORTED_REPORTS = 'export-status',
  TEACHER_EDIT_PROFILE_REQUEST = 'teacher-edit-profile-request',
}
